exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".header {\n  padding: 0; }\n  .header__logo {\n    display: block;\n    margin: 0 auto;\n    max-width: 100%; }\n    @media (max-width: 576px) {\n      .header__logo {\n        max-width: 260px; } }\n", ""]);
